import { Container } from '@mui/material';
import { ReactNode } from 'react';
import { Box, SxProps } from '@mui/system';

export interface PageWrapperProps {
  children?: ReactNode;
  fullPage?: boolean;
  sx?: SxProps;
}

export function PageWrapper({ children, fullPage, sx }: PageWrapperProps): React.JSX.Element {
  return (
    <Box
      sx={{
        pt: 2,
        mb: 2,
        px: {
          xs: 2,
          sm: 0,
        },
        ...sx,
      }}
    >
      {fullPage
        ? children
        : (
          <Container
            maxWidth="xl"
            fixed
            disableGutters
          >
            {children}
          </Container>
        )}
    </Box>
  );
}
